// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"03da4752680818de80d1","655":"afc207378addc19386fa"}[chunkId] + ".js";
};